import React from 'react';
import { Link } from 'react-router-dom';
import { FaClock } from 'react-icons/fa';

const Coming = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] bg-[#FAF9F6] p-4 text-slate-900">
      <div className="bg-white p-8 rounded-3xl shadow-sm border border-slate-200/80 w-full max-w-md text-center">
        <div className="w-12 h-12 rounded-2xl bg-indigo-50 text-indigo-600 border border-indigo-100 flex items-center justify-center text-xl mx-auto mb-4">
          <FaClock />
        </div>
        <h1 className="text-2xl font-extrabold mb-2 text-slate-900">In Active Development</h1>
        <p className="text-sm text-slate-500 mb-6 font-medium">
          This developer portal feature is currently being implemented. Check back soon or track progress on GitHub.
        </p>
        <Link
          to="/"
          className="inline-flex items-center justify-center px-6 py-3 rounded-2xl text-xs font-bold text-white bg-slate-900 hover:bg-slate-800 transition shadow-sm"
        >
          ← Return to Sponsorship Hub
        </Link>
      </div>
    </div>
  );
};

export default Coming;